import request from '@/utils/changanRequest'

// 查询业务信息列表
export function listbusinessInfo(query) {
  return request({
    url: '/system/businessInfo/list',
    method: 'get',
    params: query
  })
}

// 查询业务信息详细
export function getbusinessInfo(id) {
  return request({
    url: '/system/businessInfo/' + id,
    method: 'get'
  })
}

// 新增业务信息
export function addbusinessInfo(data) {
  return request({
    url: '/system/businessInfo',
    method: 'post',
    data: data
  })
}

// 修改业务信息
export function updatebusinessInfo(data) {
  return request({
    url: '/system/businessInfo',
    method: 'put',
    data: data
  })
}

// 删除业务信息
export function delbusinessInfo(id) {
  return request({
    url: '/system/businessInfo/' + id,
    method: 'delete'
  })
}

// 查询业务信息浏览记录列表
export function listRecord(query) {
  return request({
    url: '/system/record/list',
    method: 'get',
    params: query
  })
}

// 查询业务信息浏览记录详细
export function getRecord(id) {
  return request({
    url: '/system/record/' + id,
    method: 'get'
  })
}

// 新增业务信息浏览记录
export function addRecord(data) {
  return request({
    url: '/system/record',
    method: 'post',
    data: data
  })
}

// 修改业务信息浏览记录
export function updateRecord(data) {
  return request({
    url: '/system/record',
    method: 'put',
    data: data
  })
}

// 删除业务信息浏览记录
export function delRecord(id) {
  return request({
    url: '/system/record/' + id,
    method: 'delete'
  })
}
// 查询部门下拉树结构
export function deptTreeSelect() {
  return request({
    url: "/system/user/deptTree",
    method: "get",
  });
}
export function listZonePark(query) {
  return request({
    url: '/system/zonePark/list',
    method: 'get',
    params: query
  })
}